import { render, staticRenderFns } from "./PaginationSmall.vue?vue&type=template&id=cd43a4ee&"
import script from "./PaginationSmall.vue?vue&type=script&lang=js&"
export * from "./PaginationSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports